import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7733481a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-action" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { class: "m-claim__buy-button__price" }
const _hoisted_9 = {
  key: 0,
  class: "m-claim__allowlist-message"
}
const _hoisted_10 = { id: "signature-prompt" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Enter Claim Code", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { id: "signature-prompt-buttons" }
const _hoisted_14 = {
  key: 0,
  id: "signature-prompt-success"
}

import { computed, onBeforeMount, ref, watch } from 'vue';
import { signatureApi } from '@/api/apiHelpers';
import Spinner from '@/components/Spinner.vue';
import { useDates } from '@/composables/dates';
import { SigMintError, useClaimStore } from '@/store/claimStore';

const DEAD_ADDRESS = '0x000000000000000000000000000000000000000000000000000000000000dead';
const DEAD = '0x000000000000000000000000000000000000dead';

export default /*#__PURE__*/_defineComponent({
  __name: 'SignaturePromptButton',
  setup(__props) {

_useCssVars(_ctx => ({
  "4a36dad5": (_unref(store).clientColors.themePrimary)
}))

const store = useClaimStore();
const { claimStartDate, claimEndDate, getCalendarString } = useDates();
const openModal = ref(false);
const showModal = ref(false);
const _redemptionCode = ref('');
const input = ref<HTMLInputElement>();
const success = ref(false);
const loading = ref(false);
const error = ref<SigMintError>();

const allowlistUpdating = computed(() => {
  return store.merkleRoot === DEAD_ADDRESS;
});

const mintButtonLabel = computed(() => {
  if (store.isFreeClaim) {
    return 'Claim Now';
  } else {
    return 'Buy Now';
  }
});

onBeforeMount(() => {
  const params = new URLSearchParams(document.location.search);
  const maybeRedemptionCode = params.get('code');

  if (maybeRedemptionCode) {
    _redemptionCode.value = maybeRedemptionCode;
    checkCode();
  }
});

watch(_redemptionCode, () => {
  error.value = undefined;
});

watch(openModal, (newValue: boolean, oldValue: boolean) => {
  if (newValue && !oldValue) {
    setTimeout(() => {
      if (newValue) {
        showModal.value = true;
      }
    }, 250);
  }
  if (!newValue && oldValue) {
    setTimeout(() => {
      if (store.redemptionCodeValidated) {
        document.getElementById('buy-button')?.click();
      }
    }, 750);
  }
});

watch(showModal, (value: boolean) => {
  setTimeout(() => {
    if (!value && openModal.value) {
      openModal.value = false;
    } else {
      input.value?.focus();
    }
  }, 250);
});

watch(success, (value: boolean) => {
  if (value) {
    setTimeout(() => {
      // This will visually close this component
      showModal.value = false;
      setTimeout(() => {
        // This will unmount this component
        store.setRedemptionCode(_redemptionCode.value);

        setTimeout(() => {
          // This will open the checkout modal
          if (store.redemptionCodeValidated) {
            document.getElementById('buy-button')?.click();
          }
        }, 750);
      }, 500);
    }, 1000);
  }
});

watch(input, (value: HTMLInputElement | undefined) => {
  if (value) {
    value.focus();
  }
});

const errorMessage = computed(() => {
  if (error.value === SigMintError.BAD_SECRET) {
    return 'Invalid code';
  } else if (error.value === SigMintError.SERVER_ERROR) {
    return 'Server error';
  } else if (error.value === SigMintError.USED_OTP) {
    return 'Code already used';
  } else {
    return 'Something went wrong';
  }
});

const checkCode = async () => {
  if (_redemptionCode.value) {
    loading.value = true;

    try {
      const mintCount = 1;
      const { message, signature, nonce, expiration } = await signatureApi.redemptionSign({
        instanceId: store.id,
        extensionAddress: store.extensionAddress,
        redemptionCode: _redemptionCode.value,
        walletAddress: DEAD,
        mintCount,
      });

      // Simulate transaction by estimating gas to verify if nonce is still valid.
      const contractToCall = store.overrideMintExtensionAddress
        ? store.overrideMintContract
        : store.contract;
      const feeToUse = await contractToCall.getMintFee();
      const paymentAmount = store.cost.add(feeToUse).mul(mintCount);

      await contractToCall.estimateGasMintSignature(
        DEAD,
        DEAD,
        mintCount,
        signature,
        message,
        nonce,
        expiration,
        paymentAmount,
        true
      );
      success.value = true;
    } catch (e: any) {
      if (openModal.value) {
        if (e.status === 406) {
          error.value = SigMintError.BAD_SECRET;
        } else if (e.status === 500) {
          error.value = SigMintError.SERVER_ERROR;
        } else {
          error.value = SigMintError.USED_OTP;
        }
      } else {
        _redemptionCode.value = '';
      }
    }
  }
  loading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal.value = true)),
        class: "campaign-buy-button",
        disabled: 
        _unref(store).isLoadingWeb3State ||
        _unref(store).isDelegationLoading ||
        _unref(store).isSoldOut ||
        _unref(store).status === 'not-started' ||
        _unref(store).status === 'ended' ||
        allowlistUpdating.value ||
        loading.value ||
        success.value
      
      }, [
        (loading.value || success.value || _unref(store).isLoadingWeb3State || _unref(store).isDelegationLoading)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              dark: ""
            }))
          : (_unref(store).status === 'not-started')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Drops " + _toDisplayString(_unref(getCalendarString)(_unref(claimStartDate))), 1))
            : (_unref(store).status === 'ended')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Ended " + _toDisplayString(_unref(getCalendarString)(_unref(claimEndDate))), 1))
              : (_unref(store).isSoldOut)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Sold out"))
                : (_unref(store).sigMintError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(store).sigMintErrorMessage), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(mintButtonLabel.value) + " · ", 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(store).priceDisplayText), 1)
                    ]))
      ], 8, _hoisted_2)
    ]),
    (allowlistUpdating.value && _unref(store).status === 'active' && !_unref(store).isSoldOut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " The creator is finalizing eligibility requirements. Please check back later. "))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: ".m-claim" }, [
      (openModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "signature-prompt-container",
            class: _normalizeClass({ show: showModal.value })
          }, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                ref_key: "input",
                ref: input,
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_redemptionCode).value = $event)),
                class: _normalizeClass({ bad: error.value === _unref(SigMintError).BAD_SECRET || error.value === _unref(SigMintError).USED_OTP })
              }, null, 2), [
                [_vModelText, _redemptionCode.value]
              ]),
              _createElementVNode("div", _hoisted_13, [
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Success"))
                  : (!loading.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false))
                        }, "Cancel"),
                        _createElementVNode("button", { onClick: checkCode }, "Submit")
                      ], 64))
                    : (_openBlock(), _createBlock(Spinner, { key: 2 }))
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})